// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveInstitutionPresidentDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import InstitutionPresidentDTO from '../models/InstitutionPresidentDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionId: string | null;
    institutionPresident: InstitutionPresidentDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionId: '00000000-0000-0000-0000-000000000000',
            institutionPresident: null,
        },
        initValues);
    },
    institutionId: 'institutionId',
    institutionPresident: 'institutionPresident',
}

interface Result extends ResultDTO {
    institutionPresident: InstitutionPresidentDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            institutionPresident: null,
        },
        initValues);
    },
    institutionPresident: 'institutionPresident',
}

export { Request, Result };